<div class="container-fluid">
  <div class="row section1">
    <div class="col-12 col-md-7 col-lg-4 col-xl-4">
      <div class="home-details">
        <h5 class="home-title">Review Details</h5>
      </div>
    </div>
    <div class="col-12 col-md-8 col-lg-6 col-xl-6">
      <div class="dashboard-btn dashboard-manage">
        <div><a (click)="goBack()">
          <button class="btn btn-primary btn-dashboard">Back</button>
        </a></div>
        <!-- <div> <a [routerLink]="['/edit-entity/', entityId]"><button class="btn btn-primary btn-deshboard">Edit
              Details</button></a></div> -->
        <!--        <div class="cog-icn"><a><i class="las la-redo-alt"></i></a></div>-->
        <!--        <div class="cog-icn"><a><i class="las la-times"></i></a></div>-->
      </div>
    </div>
  </div>
  <div class="row section1">
    <div class="col-12 col-md-6 col-lg-5 col-xl-5">
      <div class="applicants-details details1 pt-4">
        <h6 class="job-title">Reviewer Details</h6>
        <hr class="border2">
        <div class="row">
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user"><p>Reviewer Id</p></div>
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1"><p>{{review.user.id}}</p></div>
        </div>
        <hr class="border2">
        <div class="row">
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user "><p>Reviewer Name</p></div>
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1"><p>{{review.user.fullName}}</p></div>
        </div>
        <hr class="border2">
        <div class="row">
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user "><p>Reviewer Email</p></div>
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1"><p>{{review.user.email}}</p></div>
        </div>
        <hr class="border2">
        <h6 class="job-title">Entity Details</h6>
        <hr class="border2">
        <div class="row">
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user "><p>Entity ID</p></div>
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1"><p>{{review.entity.id}}</p></div>
        </div>
        <hr class="border2">
        <div class="row">
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user "><p>Entity Name</p></div>
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1"><p>{{review.entity.entityName}}</p></div>
        </div>
        <hr class="border2">
        <div class="row">
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user "><p>Entity Category</p></div>
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1"><p>{{review.category.categoryName}}</p></div>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6 col-lg-5 col-xl-5">
      <div class="applicants-details details1 pt-4 mb-3 pb-0">
        <h6 class="job-title">Review Details</h6>
        <hr class="border2">
        <div class="row">
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user "><p>Review Id</p></div>
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1"><p>{{review.id}}</p></div>
        </div>
        <hr class="border2">
        <div class="row">
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user "><p>Review Category</p></div>
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1"><p>{{review.parameter.fieldName}}</p></div>
        </div>
        <hr class="border2">
        <div class="row">
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user "><p>Rating</p></div>
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1"><p>{{review.value.rating}}</p></div>
        </div>
        <hr class="border2">
        <div class="row">
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user "><p>Review</p></div>
          <div class="col-6 col-md-6 col-lg-6 col-xl-6 single-user user1"><p>{{review.value.message}}</p></div>
        </div>
      </div>
    </div>
  </div>
</div>
